export default "__VITE_ASSET__1d13e2ea__"